import './index.scss';
import { Option } from '@vaaas/fpts/option';
import { ID } from '@phi/newtype';
import { AnyBody, OnshapeElement } from '@phi/onshape';
import { PropType, defineComponent, h, onMounted, ref } from 'vue';
import { getPartStudioBodyDetails } from '@phi/frontend/api/calls';
import ListGroupSelect from '@components/ListGroupSelect';
import { OnshapeElementThumbnail, OnshapePartThumbnail } from '@features/onshape-thumbnails/components';
import { Button, LoadingIndicator } from '@phi/components';
import { vif1 } from '@phi/util/vuetils';

export default defineComponent({
    props: {
        document: {
            required: true,
            type: String as any as PropType<ID<'document'>>,
        },

        workspace: {
            required: true,
            type: String as any as PropType<ID<'workspace'>>,
        },

        element: {
            required: true,
            type: Object as PropType<OnshapeElement>,
        },

        part: {
            required: true,
            type: null as any as PropType<Option<AnyBody>>,
        },
    },

    emits: {
        'update:part': (x: Option<AnyBody>) => true,
        back: () => true,
    },

    setup(props, ctx) {
        const bodies = ref([undefined] as Array<AnyBody | undefined>);
        const PartSelect = ListGroupSelect<AnyBody | undefined>();

        const fetching = ref(false);
        async function fetch_parts() {
            fetching.value = true;
            await getPartStudioBodyDetails(props.document, props.element.id, props.workspace, true)
                .then(x => {
                    if (!(x instanceof Error))
                        bodies.value.push(...x.bodies);
                });
            fetching.value = false;
        }

        onMounted(fetch_parts);

        function renderer(x: AnyBody) {
            return [
                h(OnshapePartThumbnail, {
                    document: props.document,
                    workspace: props.workspace,
                    element: props.element.id,
                    part: x.id,
                }),

                h('span', { class: 'name' }, x.properties.name),
            ];
        }

        const entire_part_studio = [
            h(OnshapeElementThumbnail, {
                value: props.element,
                document: props.document,
                workspace: props.workspace,
            }),

            h('span', { class: 'name' }, 'Select entire Part Studio')
        ];

        return () => h('div', { class: 'onshape-part-explorer' }, [
            h('header',
                h(Button, {
                    onClick: () => ctx.emit('back'),
                }, () => 'Back'),
            ),
            LoadingIndicator(!fetching.value),
            vif1(!fetching.value)(() => h(PartSelect, {
                value: props.part,
                items: bodies.value.map(x => ({
                    key: x ? x.id : x,
                    value: x,
                    node: x ? renderer(x) : entire_part_studio,
                })),
                'onUpdate:value': x => ctx.emit('update:part', x),
            })),
        ]);
    },
});
